import { motion } from "framer-motion";

export default function Reveal({
    children,
    delay = 0,
    y = 28,
    className = "",
    ...rest
}) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
            {...rest}
        >
            {children}
        </motion.div>
    );
}
